import React from 'react';
import PersonIcon from "@mui/icons-material/Person";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import GroupsIcon from "@mui/icons-material/Groups";
import ListAltIcon from '@mui/icons-material/ListAlt';
import BarChartSharpIcon from '@mui/icons-material/BarChartSharp';
import FolderIcon from '@mui/icons-material/Folder';
import PsychologyIcon from '@mui/icons-material/Psychology';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import PeopleIcon from '@mui/icons-material/People';
import BallotIcon from '@mui/icons-material/Ballot';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';

var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";

export const MenuItems = [
  {
    title: "My Account",
    icon: <PersonIcon />,
    to: "/myaccount",
  },
  {
    title: "OKRs",
    icon: <FolderIcon />,
    to: "#",

    items: [
      {
        title: "View All OKRs",
        icon: <ListAltIcon />,
        to: "/listokrs",

      },
      {
        title: "My OKRs",
        icon: <BarChartSharpIcon />,
        to: "/myokrs",

      }
    ]
  },

  {
    title: "Org. Structure",
    icon: <AccountTreeIcon />,
    to: "/orgchart",
  },
  {
    title: "Employee Directory",
    icon: <GroupsIcon />,
    to: "/employee-directory",
  },
  {
    title: "Training",
    icon: <PsychologyIcon />,
    to: "#",
    items:
      isUserLogged.usertype === "Admin" || isUserLogged.usertype === "TrainingManager" || isUserLogged.usertype === "SuperAdmin" ?
        [
          {
            title: "Training Courses",
            icon: <BallotIcon />,
            to: "/training",
          },
          {
            title: "My Training Classes",
            icon: <BarChartSharpIcon />,
            to: "/trainings/mytrainings",
          },
          {
            title: "Team Training",
            icon: <PeopleIcon />,
            to: "/trainings/team",
          }
        ] :
        isUserLogged.isManager === true ?
          [{
            title: "Training Courses",
            icon: <BallotIcon />,
            to: "/trainings/alltrainings",
          },
          {
            title: "My Training Classes",
            icon: <BarChartSharpIcon />,
            to: "/trainings/mytrainings",
          },
          {
            title: "Team Training",
            icon: <PeopleIcon />,
            to: "/trainings/team",
          }] :
          [{
            title: "Training Courses",
            icon: <BallotIcon />,
            to: "/trainings/alltrainings",
          },
          {
            title: "My Training Classes",
            icon: <BarChartSharpIcon />,
            to: "/trainings/mytrainings",
          }]
  },
  {
    title: "Reviews",
    icon: <CoPresentIcon />,
    to: "#",
    items: isUserLogged.isManager ?
      [
        {
          title: "Performance",
          icon: <ShowChartIcon />,
          to: "/performance"
        },
        {
          title: "Value Analysis",
          icon: <AssessmentIcon />,
          to: "/value-analysis"
        },
        {
          title: "Annual Appraisal",
          icon: <EventRepeatIcon />,
          to: "annual-appraisal",
        }
      ]

      :
      [
        {
          title: "Performance",
          icon: <ShowChartIcon />,
          to: "/performance"
        },
        {
          title: "Annual Appraisal",
          icon: <EventRepeatIcon />,
          to: "annual-appraisal",
        }
      ]
  }

];